import React, { useEffect, useState } from "react";
import BeneficiaryList from "./beneficiaryList";
import { isNumber } from "../../Utils/Common";
import { toast } from "react-toastify";
import PropagateLoader from "react-spinners/PropagateLoader";
import { POST_DMT_PAY_SPRINT_CUSTOMER_DETAIL } from "../../Utils/appConstants";
import { postRequest } from "../../Utils/AppApi";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import { Modal, DatePicker, Divider } from "antd";
import DmtAadharVerify from "../dmtAadharVerify";
import finoLogo from '../../assets/fino_logo.png';

function ViewCustomer({ findCustomerInfo }) {
    const history = useHistory();
    const location = useLocation();

    const dateFormat = "DD-MM-YYYY";
    const [customerData, setCustomerData] = useState(null);
    const [isLoading, setLoading] = useState(false);
    const [getDataField, setDataField] = useState({});
  

    useEffect(() => {
        const stateCustomer = location.state?.customerData;
        if (!stateCustomer) {
            console.error("No customer data found in location.state");
            return;
        }

        console.log("Setting customerData:", stateCustomer);
        setCustomerData(stateCustomer);

        const lastDate = moment().subtract(19, "years");
        const dateValue = moment(lastDate);

        setDataField({
            name: stateCustomer.customerName || "",
            address: stateCustomer.area || "",
            pincode: stateCustomer.pincode || "",
            dateOfBirth: stateCustomer.customerDob || dateValue.format(dateFormat),
        });
        // setDateOfBirth(dateValue);

        // if (!stateCustomer.area || !stateCustomer.customerDob) {
        //     setSrpayKycModal(true);
        // }
    }, [location.state]);

    



    if (isLoading) {
        return (
            <div className="content text-center" style={{ margin: "250px 0" }}>
                <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
            </div>
        );
    }

    if (!customerData) {
        return <div>No customer data available. Please search again.</div>;
    }

    const pipeInstantTransfer = customerData.pipeInstantTransfer || "N";

 return (
    <section className="d-flex flex-column min-vh-100">
        <div className="row flex-grow-1 d-flex align-items-stretch">
            <div className="col p-0 col-xl-12">
                <div className="card h-100" style={{ borderRadius: 15 }}>
                    <div className="card-body d-flex flex-column">
                        <div className="d-flex">
                            <div className="col-md-11">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h3 className="mb-3">{customerData.customerName}</h3>
                                    <img
                                        src={finoLogo}
                                        alt="Company Logo"
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                            objectFit: "contain",
                                        }}
                                    />
                                </div>

                                <p className="mb-0 fx-14 text-dark">
                                    <i className="fas fa-star fa-lg text-warning" />
                                    <span className="mx-2">|</span>
                                    Mobile: <strong>{customerData.customerMobile}</strong>
                                    <span className="mx-2">|</span>
                                    Available Limit: <strong>{customerData.availableLimit}</strong>
                                    <span className="mx-2">|</span>
                                    Status: <strong>{pipeInstantTransfer}</strong>
                                    <span className="mx-2">|</span>
                                </p>
                            </div>
                        </div>

                        <hr className="my-2" />

                        {customerData.isVerified && (
                            <ErrorBoundary>
                                <BeneficiaryList customerData={customerData} />
                            </ErrorBoundary>
                        )}
                    </div>
                </div>
            </div>
        </div>
    </section>
);

}

class ErrorBoundary extends React.Component {
    state = { error: null };
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return <div>Error: {this.state.error.message}</div>;
        }
        return this.props.children;
    }
}

export default ViewCustomer;
